import { DatePipe } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { HistoryItemResponse, MessageContent } from '@shared/index';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { SupervisorNotificationComponent } from '../supervisor-notification/supervisor-notification.component';
import { SupervisorService } from '../supervisor.service';

@Component({
  selector: 'app-supervisor-chat',
  imports: [DatePipe, SupervisorNotificationComponent, TableModule, DialogModule, ButtonModule, TooltipModule],
  templateUrl: './supervisor-chat.component.html',
  styleUrl: './supervisor-chat.component.scss'
})
export class SupervisorChatComponent implements AfterViewInit {
  public allTimeMeasures: Map<string, number> = new Map<string, number>();
  public codeDialogVisible = false;
  public codeDialogContent = '';

  constructor(public supervisorService: SupervisorService) { }

  public openCodeDialog(content: string): void {
    try {
      this.codeDialogContent = JSON.stringify(JSON.parse(content), null, 2);
    } catch {
      this.codeDialogContent = content;
    }
    this.codeDialogVisible = true;
  }

  public ngAfterViewInit(): void {
    setTimeout(async () => {
      await this.supervisorService.scrollDown();
    });
  }

  public getHistoryItemByIndex(index: number): HistoryItemResponse | undefined {
    if (this.supervisorService.selectedThread) {
      return this.supervisorService.selectedThread[index];
    }
    return undefined;
  }

  protected getTextFromMessageContent(content: MessageContent[]) {
    let m = '';
    const msg = content.at(0);
    if (msg?.type === 'text') {
      m = msg.text;
    }
    return m;
  }
}
